import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Form, Input, Drawer, Button, Row, Col, DatePicker, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { createGlobalLeave, updateGlobalLeave, getGlobalLeaves } from "../../../../actions/globalLeaveAction";

const { RangePicker } = DatePicker;

const CreateGlobalLeave = ({ visible, onCancel, setUpdatelist, editData = null }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        title: editData.title,
        note: editData.note,
        dateRange: [editData.leaveStart, editData.leaveEnd],
      });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const onClose = () => {
    form.resetFields();
    onCancel();
  };

  const onFinish = async (values) => {
    const payload = {
      title: values.title,
      leaveStart: values.dateRange[0].format("YYYY-MM-DD"),
      leaveEnd: values.dateRange[1].format("YYYY-MM-DD"),
      note: values.note || "",
    };

    try {
      setLoading(true);
      if (editData) {
        await dispatch(updateGlobalLeave(editData.id, payload));
        message.success("Global Leave updated successfully");
      } else {
        await dispatch(createGlobalLeave(payload));
        message.success("Global Leave created successfully");
      }

      setUpdatelist(false);
      onClose();
      dispatch(getGlobalLeaves());
    }  catch (err) {
      console.error(err);
      message.error("Something went wrong!");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Drawer
      title={editData ? "Edit Global Leave" : "Create Global Leave"}
      width={400}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }} disabled={loading}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => form.submit()} loading={loading}>
            {editData ? "Update" : "Create"}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter a title" }]}
            >
              <Input placeholder="e.g., Eid Holiday" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="dateRange"
              label="Leave Period"
              rules={[{ required: true, message: "Please select start and end date" }]}
            >
              <RangePicker />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="note" label="Note">
              <Input.TextArea rows={3} placeholder="Optional notes" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
    
  );
};

export default connect(null, { createGlobalLeave, updateGlobalLeave })(CreateGlobalLeave);
